module.exports = __webpack_public_path__ + "static/img/xk2.0ac186c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xk2.png
// module id = a1LU
// module chunks = 0